import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';

/** Fallback route colour, used when a route has no colour set. */
export const DEFAULT_ROUTE_COLOUR = '#646463';

/**
 * Builds the style for a route line during an edit session: a dashed line in the
 * route's own colour, with a white casing and matching vertices — so the edited
 * line still reads as that route while the dashes signal edit mode. Used by both
 * the working vector layer (GpxEditSession) and the extend sketch
 * (GpxEditInteractions) so the two can't drift.
 */
export function createEditLineStyle(colour: string = DEFAULT_ROUTE_COLOUR): Style[] {
    const dash = [8, 8];
    return [
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 0.8)',
                width: 7,
                lineDash: dash
            })
        }),
        new Style({
            stroke: new Stroke({
                color: colour,
                width: 5,
                lineDash: dash
            }),
            image: new Circle({
                radius: 5,
                fill: new Fill({ color: colour }),
                stroke: new Stroke({ color: '#ffffff', width: 1.5 })
            })
        })
    ];
}
